// @ts-nocheck
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";

export const ProgressCounter = ({
  progressTitle = "Accepted",
  totalCount = 10,
  currentCount = 0,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.25rem 0.5rem",
        border: "2px solid",
        borderRadius: "1.25rem",
        borderColor: getCssVariableHandler({
          variableName: "--primary-pink-hex",
        }),
      }}
    >
      <Typography
        sx={{
          fontSize: "1rem",
          fontWeight: "500",
          color: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
          whiteSpace: "nowrap",
        }}
      >
        {`${currentCount}/${totalCount} ${progressTitle}`}
      </Typography>
    </Box>
  );
};

ProgressCounter.propTypes = {
  progressTitle: PropTypes.string,
  totalCount: PropTypes.number,
  currentCount: PropTypes.number,
};